import type { Currency } from '@/api/types/public';
import { env } from '@/utils/env';

type SupportedDefaultCurrency = NonNullable<typeof env.NEXT_PUBLIC_DEFAULT_CURRENCY>;

const DEFAULT_CURRENCY_MAP: Record<SupportedDefaultCurrency, Currency> = {
  USD: {
    name: 'USD',
    full_symbol: '$',
    symbol: '$',
    exchange_rate: '1.000000',
    symbol_prefix: '$',
    symbol_suffix: '',
  },
  EUR: {
    name: 'EUR',
    full_symbol: '€',
    symbol: '€',
    exchange_rate: '1.000000',
    symbol_prefix: '€',
    symbol_suffix: '',
  },
  CAD: {
    name: 'CAD',
    full_symbol: 'CA$',
    symbol: 'CA$',
    exchange_rate: '1.000000',
    symbol_prefix: 'CA$',
    symbol_suffix: '',
  },
  GBP: {
    name: 'GBP',
    full_symbol: '£',
    symbol: '£',
    exchange_rate: '1.000000',
    symbol_prefix: '£',
    symbol_suffix: '',
  },
};

const DEFAULT_CURRENCY_NAME = env.NEXT_PUBLIC_DEFAULT_CURRENCY;

export const DEFAULT_CURRENCY: Currency =
  DEFAULT_CURRENCY_MAP[DEFAULT_CURRENCY_NAME] || DEFAULT_CURRENCY_MAP.USD;
